import React, { useRef, useEffect } from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import { Controller } from "react-hook-form";
import { MenuProps } from "../../../utils";

export default function SelectControl(props) {
  const {
    name,
    error,
    helperText,
    optionKey = "key",
    optionValue = "value",
    optionLabel = "",
    showNoneOption = true,
    optionList = [],
    required = true,
    firstError = "",
    control,
    rules = {},
    label,
    inputProps = {},
    disabledOptionKey = [-1],
    overrideHandlers = {},
    ...rest
  } = props;
  const inputRef = useRef();

  useEffect(() => {
    if (error && error.ref && firstError === name && inputRef.current) {
      inputRef.current.focus();
    }
  }, [error, firstError, name]);

  return (
    <FormControl
      required={required}
      size="small"
      fullWidth
      margin="dense"
      error={!!error}
    >
      <InputLabel id={name}>{label}</InputLabel>
      <Controller
        name={name}
        control={control}
        defaultValue=""
        rules={rules}
        render={({ field }) => {
          return (
            <Select
              inputRef={inputRef}
              labelId={name}
              label={label}
              inputProps={inputProps}
              value={field.value}
              onBlur={inputRef?.current?.onBlur}
              onFocus={inputRef?.current?.onFocus}
              onChange={inputRef?.current?.onChange}
              MenuProps={MenuProps}
              required={required}
              {...rest}
              {...field}
              {...overrideHandlers}
            >
              {showNoneOption && <MenuItem value="">None</MenuItem>}
              {optionList.map((name) => (
                <MenuItem
                  key={name[optionKey]}
                  value={name[optionKey]}
                  disabled={disabledOptionKey.includes(name[optionKey])}
                >
                  {!!optionLabel ? name[optionLabel] : name[optionValue]}
                </MenuItem>
              ))}
            </Select>
          );
        }}
      />
      <FormHelperText error={error !== undefined}>
        {error?.message || helperText}
      </FormHelperText>
    </FormControl>
  );
}
